/**
 * Return map of raw admission answer values without the metadata.
 *
 * @param {Admission} admission The admission object.
 * @returns {object} The raw answer values.
 */
export const extractAnswerValues = ({ answers }) => {
    const rawAnswers = {};
    for (const key in answers) {
        rawAnswers[key] = answers[key].value;
    }
    return rawAnswers;
};
/**
 * Extracts the pre-flighted answers from an admission.
 *
 * @param {Admission} admission The admission object.
 * @returns {object} The pre-flighted answers.
 */
export const extractPreflightedAnswers = ({ answers }) => {
    const preflightedAnswers = {};
    for (const key in answers) {
        const answer = answers[key];
        if (answer.preFlight) {
            preflightedAnswers[key] = answer;
        }
    }
    return preflightedAnswers;
};
